import ApiService from "./ApiService";
import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "./basequery";

const servicePrefix = "/billing";

export const billingApi = createApi({
  reducerPath: "billingApi",
  baseQuery: baseQuery,
  tagTypes: ["billings"],
  refetchOnFocus: true,
  refetchOnReconnect: true,
  endpoints: (build) => ({
    createSubscription: build.mutation({
      query: ({ ...values }) => ({
        url: `${servicePrefix}/subscribe/`,
        method: "post",
        data: { ...values },
      }),
      invalidatesTags: [{ type: "billings", id: "LIST" }],
    }),

    getBillingDetails: build.query({
      query: () => ({
        url: `${servicePrefix}/`,
        method: "get",
      }),
      providesTags: (result) =>
        result?.results
          ? [
              ...result?.results?.map?.(({ id }) => ({ type: "billings", id })),
              { type: "billings", id: "LIST" },
            ]
          : [{ type: "billings", id: "LIST" }],
    }),

    cancelSubscription: build.mutation({
      query: () => ({
        url: `${servicePrefix}/cancel/`,
        method: "post",
      }),
      invalidatesTags: [{ type: "billings", id: "LIST" }],
    }),

    getBillingVolume: build.query({
      query: () => ({
        url: `${servicePrefix}/volume/`,
      }),
    }),

    convertAmountCurrency: build.mutation({
        query: ({ ...values }) => ({
            url: `${servicePrefix}/convert-amount/`,
             method: "post",
            data: { ...values },
        })
    })
  }),
});

export const {
  useCancelSubscriptionMutation,
  useCreateSubscriptionMutation,
  useGetBillingDetailsQuery,
  useGetBillingVolumeQuery,
useConvertAmountCurrencyMutation
} = billingApi;

export async function apiCreateSubscription(data) {
  return ApiService.fetchData({
    url: servicePrefix + "/subscribe/",
    method: "post",
    data,
  });
}
export async function apiGetBillingDetails() {
  return ApiService.fetchData({
    url: servicePrefix + "/",
    method: "get",
  });
}
export async function apiCancelSubscription() {
  return ApiService.fetchData({
    url: servicePrefix + "/cancel/",
    method: "post",
  });
}
